module.exports = __webpack_public_path__ + "img/sign-top.84fd5001.png";